import { createFileRoute } from "@tanstack/react-router";
import Bokforing from "@/pages/Bokforing";
import { buildBreadcrumbSchema, getBreadcrumbTrail, buildPageSchema, buildSeoHead, buildServiceSchema, publicPageSeo } from "@/data/seo";

export const Route = createFileRoute("/bokforing")({
  head: () =>
    buildSeoHead(
      publicPageSeo.bokforing,
      [
        buildPageSchema(publicPageSeo.bokforing, "WebPage"),
        buildServiceSchema(publicPageSeo.bokforing, "Löpande bokföring", [
          "Digital bokföring",
          "Avstämningar",
          "Rapportering",
          "Proaktiv rådgivning",
        ]),
        buildBreadcrumbSchema(getBreadcrumbTrail("/bokforing") ?? []),
      ],
    ),
  component: Bokforing,
});
